// import { DatePipe } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs';
// import { concatLatestFrom } from '@ngrx/operators';
// import { catchError, filter, of, switchMap } from 'rxjs';

// import { AuthService } from '../../../../_core/services/auth.service';
import { AppLoadService } from '@ninety/platform/services/services/app-load.service';
import { CookieService } from '@ninety/platform/services/services/cookie.service';

// import { StorageKeyPrefix, StorageService } from '../../../../_core/services/storage.service';
// import { TokenService } from '../../../../_core/services/token.service';
// import { appActions } from '@ninety/platform/state/app.actions';
import { BaseEffects } from '../../../base.effects';
import { AuthActions } from '../auth.actions';
// import { AuthStateSelectors } from '../auth.selectors';
// import { LogOutActions } from '@ninety/platform/state/app-global/auth/logout/logout.actions';
// import { Tokens } from '@ninety/platform/state/app-global/auth/services/refresh-token';

@Injectable()
export class TokenEffects extends BaseEffects {
  // storageService = inject(StorageService);
  cookieService = inject(CookieService);
  private readonly appLoadService = inject(AppLoadService);
  // tokenService = inject(TokenService);
  // authService = inject(AuthService);

  /** Bridges tokens refreshed during `AppLoadService` startup to the auth state (services -> state inversion). */
  setRefreshTokens$ = createEffect(() =>
    this.appLoadService.refreshTokensSaved$.pipe(map(tokens => AuthActions.setRefreshTokens({ tokens })))
  );

  // bootstrap_checkTokens$ = this.mapEffect({
  //   action: appActions.bootstrap,
  //   mapFn: () => AuthActions.refreshToken(),
  // });

  // Note: Reactivate when the auto refresh has been removed from AuthService
  // autoRefresh$ = createEffect(() =>
  //   interval(60000 * 25).pipe(
  //     concatLatestFrom(() => this.store.select(AuthStateSelectors.isAuthenticated)),
  //     filter(([, isAuthenticated]) => isAuthenticated),
  //     map(() => AuthActions.refreshToken())
  //   )
  // );

  // setRefreshTokenStart$ = this.mapEffect({
  //   action: appActions.bootstrap,
  //   mapFn: () => AuthActions.refreshTokenStart(),
  // });

  // refreshToken_preventRefresh_refreshFailure$ = this.tapEffect({
  //   action: AuthActions.refreshTokenFail,
  //   tapFn: () => {
  //     this.storageService.delete(StorageKeyPrefix.COMPANY_SWITCH);
  //     this.storageService.set(StorageKeyPrefix.PREVENT_TOKEN_REFRESH, new Date().toISOString());
  //   },
  // });

  // refreshToken_preventRefresh_logout$ = this.tapEffect({
  //   action: LogOutActions.initiateLogOut,
  //   tapFn: () => {
  //     this.storageService.delete(StorageKeyPrefix.COMPANY_SWITCH);
  //     this.storageService.set(StorageKeyPrefix.PREVENT_TOKEN_REFRESH, new Date().toISOString());
  //   },
  // });

  // refreshToken_allowRefresh_tier1DataSuccess$ = this.tapEffect({
  //   action: appActions.setTier1Data,
  //   tapFn: () => {
  //     this.storageService.delete(StorageKeyPrefix.COMPANY_SWITCH);
  //     this.storageService.delete(StorageKeyPrefix.PREVENT_TOKEN_REFRESH);
  //   },
  // });

  // refreshToken_prevented_emptyPathname_redirectToLogin$ = this.tapEffect({
  //   action: AuthActions.refreshToken,
  //   tapFn: () => {
  //     const preventTokenRefresh = this.storageService.get(StorageKeyPrefix.PREVENT_TOKEN_REFRESH);
  //     const isCompanySwitching = this.storageService.get(StorageKeyPrefix.COMPANY_SWITCH);
  //     const isEmptyPathname = window.location.pathname === '/' || window.location.pathname === '';
  //     if (preventTokenRefresh && !isCompanySwitching && isEmptyPathname) {
  //       window.location.replace('/login');
  //     }
  //   },
  // });

  // refreshToken$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(AuthActions.refreshToken),
  //     map(() => {
  //       const lastRefreshError = this.storageService.get(StorageKeyPrefix.PREVENT_TOKEN_REFRESH);
  //       const lastRefreshDate = new Date(lastRefreshError).getTime();
  //       const now = Date.now();
  //       // If the last refresh error was within the last 30 seconds, treat as error
  //       const refreshError = lastRefreshError && now - lastRefreshDate <= 30000;

  //       return {
  //         isAllowedPath: !(
  //           window.location.pathname.endsWith('sign-up') || window.location.pathname.endsWith('accept-invite')
  //         ),
  //         refreshError,
  //         isCompanySwitching: this.storageService.get(StorageKeyPrefix.COMPANY_SWITCH),
  //       };
  //     }),
  //     concatLatestFrom(() => this.store.select(AuthStateSelectors.tokenRefreshInProgress)),
  //     filter(
  //       ([{ isAllowedPath, refreshError }, refreshInProgress]) => isAllowedPath && !refreshError && !refreshInProgress
  //     ),
  //     switchMap(([{ isCompanySwitching }]) => {
  //       if (isCompanySwitching) {
  //         const accessToken = this.tokenService.getAccessToken();
  //         const xsrfToken = this.cookieService.getXsrfCookie();
  //         return of(AuthActions.setRefreshTokens({ tokens: { access: accessToken, xsrf: xsrfToken } }));
  //       }
  //       return this.authService.refreshAccessToken().pipe(
  //         map(({ tokens }) => {
  //           if (!tokens?.access) {
  //             return LogOutActions.initiateLogOut(); // If no access token, log out
  //           }
  //           this.saveTokens(tokens);
  //           return AuthActions.setRefreshTokens({ tokens });
  //         }),
  //         catchError((_err: unknown) => {
  //           // If we can't refresh the token, we need to log out the user and have them log in again
  //           return of(LogOutActions.initiateLogOut());
  //         })
  //       );
  //     })
  //   )
  // );

  // private saveTokens(tokens: Tokens) {
  //   const datePipe = new DatePipe('en-US'); // this.stateService.locale
  //   const lastLoginDate = datePipe.transform(Date.now(), 'yyyy-MM-dd');
  //   if (lastLoginDate) {
  //     localStorage.setItem('lastLoginDate', lastLoginDate);
  //   }

  //   if (tokens?.access) {
  //     this.tokenService.setAccessToken(tokens.access);
  //   }

  //   if (tokens?.xsrf && !this.cookieService.getXsrfCookie()) {
  //     this.cookieService.setXsrfCookie(tokens.xsrf);
  //   }

  //   if (tokens?.ninetyUserId && !this.cookieService.getNinetyUserIdCookie()) {
  //     this.cookieService.setNinetyUserIdCookie(tokens.ninetyUserId);
  //   }
  // }
}
